/* eslint-disable jsx-a11y/anchor-is-valid */
import { itemsGroupService } from "../../services/itemGroup.service";
import { useContext, useEffect, useState } from "react";
import underscore from "underscore";
import { useForm } from "react-hook-form";
// import "../../../pages/ItemInformation.css";

import { GetGroupEdit } from "../../store/itemGroupAtom";
import { useNavigate } from "react-router-dom";
import TypeSelect from "../item-page/AddItemFormProps/TypeSelect";
import AlertConfirm from "../../helpers/AlertConfirm";
import PlanFeatureSelect from "./PlanFeatureSelect";
import { formatFormError } from "../../helpers/formartFormError";
import LogicContext from "../../Context/LogicContext";

function AddItemGroupForm(props) {
  const navigate = useNavigate();
  const [backgroundColor, setBackgroundColor] = useState("#fff");
  const logicContext = useContext(LogicContext);

  let editableGroup = GetGroupEdit();

  const [alertState, setAlertState] = useState(false);

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setValue("Item_Group_Type_Id", 1); //setting default type
    if (editableGroup?.Item_Group_Id) {
      setValue("Item_Group_Id", editableGroup?.Item_Group_Id);
      setValue("Item_Group_Type_Id", editableGroup?.Item_Group_Type_Id);
      setValue("Item_Group_Name", editableGroup?.Item_Group_Name);
      setValue("Item_Group_Category_Id", editableGroup?.Item_Group_Category_Id);
      setValue("Item_Group_Unit_Id", editableGroup?.Item_Group_Unit_Id);
      setValue("Item_Group_Brand_Id", editableGroup?.Item_Group_Brand_Id);
      setValue(
        "Item_Group_Manufacturer_Id",
        editableGroup?.Item_Group_Manufacturer_Id
      );
      setValue("Product_Feature_Id", editableGroup?.Product_Feature_Id);
      setValue("Item_Group_Description", editableGroup?.Item_Group_Description);
      setValue("background_color", editableGroup?.Item_Group_Background_Color);
      setBackgroundColor(editableGroup.Item_Group_Background_Color);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableGroup]);

  function selectGroupType(val) {
    setValue("Item_Group_Type_Id", val);
  }

  const onSubmit = async (data) => {
    setAlertState(true);
  };

  function closeAlert(response) {
    setAlertState(false);
    if (response === true) {
      props.submitForm(getValues());
    }
  }

  function onErrors(error) {
    console.error(errors);
    const errorMessages = formatFormError(errors);
    logicContext.showToast(errorMessages, "error");
  }

  const onFeatureSelect = (sel) => {
    setValue("product_feature_id", sel?.Product_Id);
  };

  const onBackgroundColorChange = (event) => {
    const selectedColor = event.target.value;
    setValue("background_color", selectedColor);
    setBackgroundColor(selectedColor);
  };

  return (
    <>
      {alertState ? (
        <AlertConfirm
          title={"Do you want to save it?"}
          body={"Please check information before submitting."}
          closeAlert={closeAlert}
        ></AlertConfirm>
      ) : null}

      <form onSubmit={handleSubmit(onSubmit, onErrors)}>
        <section className="">
          {/* TYPE SECTION */}
          <section className="flex mt-2 justify-between w-45 ">
            {/* here */}

            <TypeSelect
              defaultVal={editableGroup?.Item_Group_Type_Id}
              addItemType={selectGroupType}
            ></TypeSelect>
          </section>
          {/* ITEM INFORMATION SECTION  */}
          <div class="grid grid-cols-2 gap-4 mt-3">
            <div>
              <label className="text-sm font-medium text-gray-700">
                Item Group Name
              </label>
              <input
                className="mt-1 !h-[42px] border border-gray-200 rounded placeholder:text-gray-400 w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                type="text"
                placeholder="enter group name"
                {...register("Item_Group_Name", {
                  required: "Item group name is required",
                })}
              />
              <small className="text-red-500">
                {errors?.Item_Name && errors.Item_Name.message}
              </small>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700 mb-1">
                Product Feature
              </label>
              <PlanFeatureSelect
                defaultVal={editableGroup?.Product_Feature_Name}
                onFeatureSelect={onFeatureSelect}
              />
            </div>

            <div>
              <div className="flex flex-col">
                <label
                  className="text-sm font-medium text-gray-700 mb-1"
                  for="favcolor"
                >
                  Select Background Color:
                </label>
                <input
                  onChange={onBackgroundColorChange}
                  type="color"
                  id="favcolor"
                  style={{ width: "50px" }}
                  value={backgroundColor}
                />
              </div>
              <small className="text-red-500">
                {errors?.Item_Name && errors.Item_Name.message}
              </small>
            </div>

            <div className="">
              <span className="text-sm">
                Description <i>(Optional)</i>
              </span>
              <textarea
                {...register("Item_Group_Description")}
                className="mt-1 border border-gray-200 rounded placeholder:text-gray-400 placeholder:text-sm w-full focus:!border-blue-500 focus:!ring-1 focus:!ring-blue-500"
                rows={4}
                type="text"
                placeholder="Write a Description"
              />
            </div>
          </div>

          <section className="flex my-5 justify-end items-center">
            <a
              onClick={() => navigate(-1)}
              style={{ color: "#F17E7E", cursor: "pointer" }}
              className="py-2 px-4 text-sm rounded mr-2"
            >
              Cancel
            </a>

            <button
              type="submit"
              className="bg-blue-600 text-white hover:bg-blue-700 flex flex-row items-center text-sm font-medium px-4 py-2 rounded-md transition-colors"
            >
              Save
            </button>
          </section>
        </section>
      </form>
    </>
  );
}

export default AddItemGroupForm;
